import type { Translate } from 'types'
import { formatNumber, getAmountLabelForNumber, getDifferenceWithPrecision } from 'utils'

export function getCurrencyValue(value: number | null | undefined, currency: string, translate: Translate, precision = 2): string {
  return (
    formatNumber(value, translate, value && value < 0 ? 0 : precision) + ' ' + getAmountLabelForNumber(value, translate, currency)
  )
}

export function getPercent(value: number | null | undefined, translate: Translate): string {
  return getDifferenceWithPrecision({
    number: value,
    precision: 0,
    translate,
  }).value
}
